import { render, staticRenderFns } from "./CongratulationList.vue?vue&type=template&id=6b997e6d&scoped=true&"
import script from "./CongratulationList.vue?vue&type=script&lang=js&"
export * from "./CongratulationList.vue?vue&type=script&lang=js&"
import style0 from "./CongratulationList.vue?vue&type=style&index=0&id=6b997e6d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b997e6d",
  null
  
)

export default component.exports